import { wordPressRequest } from "./wordpress/ajax";

var pagenum = 2;

// Load More Button

document.getElementById("resourceLoadMore").onclick = () => {
	const url = phpVals.adminAjax;

	// Get Filter Categories & Industries

	var filterOptions = [];
	var checkboxes = document.getElementById("resourceFilterCategories").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < checkboxes.length; i++) {
		filterOptions.push(checkboxes[i].value);
	}

	var filterIndustryOptions = [];
	var industryCheckboxes = document.getElementById("resourceFilterIndustries").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < industryCheckboxes.length; i++) {
		filterIndustryOptions.push(industryCheckboxes[i].value);
	}

	console.log(filterOptions);
	console.log(filterIndustryOptions);

	// Setup formdata
	let data = new FormData();
	data.append("action", "bt_resource_filter");
	data.append("nonce", phpVals.btNonce);
	data.append("paged", pagenum);
	data.append("terms", filterOptions);
	data.append("industries", filterIndustryOptions);

	const params = new URLSearchParams(data);

	wordPressRequest("POST", url, params)
		.then((data) => {
			document.getElementById("resourceList").insertAdjacentHTML("beforeend", data.content);

			if (pagenum > data.max) {
				document.getElementById("resourceLoadMore").classList.add("!hidden");
			} else {
				document.getElementById("resourceLoadMore").classList.remove("!hidden");
			}
			console.log(data.query);
			console.log("Max Number of Pages");
			console.log(data.max);
			console.log("Current Page");
			console.log(pagenum);
		})
		.catch((error) => {
			console.error(error);
		});

	pagenum++;
};

// Categories Filter

document.getElementById("resourceFilterCategories").addEventListener("change", (event) => {
	pagenum = 1;
	const url = phpVals.adminAjax;

	// Get Filter Categories & Industries

	var filterOptions = [];
	var checkboxes = document.getElementById("resourceFilterCategories").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < checkboxes.length; i++) {
		filterOptions.push(checkboxes[i].value);
	}

	var filterIndustryOptions = [];
	var industryCheckboxes = document.getElementById("resourceFilterIndustries").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < industryCheckboxes.length; i++) {
		filterIndustryOptions.push(industryCheckboxes[i].value);
	}

	console.log(filterOptions);
	console.log(filterIndustryOptions);

	// Setup formdata
	let data = new FormData();
	data.append("action", "bt_resource_filter");
	data.append("nonce", phpVals.btNonce);
	data.append("paged", pagenum);
	data.append("terms", filterOptions);
	data.append("industries", filterIndustryOptions);

	const params = new URLSearchParams(data);

	wordPressRequest("POST", url, params)
		.then((data) => {
			document.getElementById("resourceList").innerHTML = "";
			document.getElementById("resourceList").insertAdjacentHTML("beforeend", data.content);
			if (pagenum > data.max) {
				document.getElementById("resourceLoadMore").classList.add("!hidden");
			} else {
				document.getElementById("resourceLoadMore").classList.remove("!hidden");
			}
			console.log(data.query);
			console.log("Max Number of Pages");
			console.log(data.max);
			console.log("Current Page");
			console.log(pagenum);
		})
		.catch((error) => {
			console.error(error);
		});

	pagenum++;
});

// Industries Filter

document.getElementById("resourceFilterIndustries").addEventListener("change", (event) => {
	pagenum = 1;
	const url = phpVals.adminAjax;

	// Get Filter Categories & Industries

	var filterOptions = [];
	var checkboxes = document.getElementById("resourceFilterCategories").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < checkboxes.length; i++) {
		filterOptions.push(checkboxes[i].value);
	}

	var filterIndustryOptions = [];
	var industryCheckboxes = document.getElementById("resourceFilterIndustries").querySelectorAll("input[type=checkbox]:checked");

	for (var i = 0; i < industryCheckboxes.length; i++) {
		filterIndustryOptions.push(industryCheckboxes[i].value);
	}

	console.log(filterOptions);
	console.log(filterIndustryOptions);

	// Setup formdata
	let data = new FormData();
	data.append("action", "bt_resource_filter");
	data.append("nonce", phpVals.btNonce);
	data.append("paged", pagenum);
	data.append("terms", filterOptions);
	data.append("industries", filterIndustryOptions);

	const params = new URLSearchParams(data);

	wordPressRequest("POST", url, params)
		.then((data) => {
			document.getElementById("resourceList").innerHTML = "";
			document.getElementById("resourceList").insertAdjacentHTML("beforeend", data.content);
			if (pagenum > data.max) {
				document.getElementById("resourceLoadMore").classList.add("!hidden");
			} else {
				document.getElementById("resourceLoadMore").classList.remove("!hidden");
			}
			console.log(data.query);
			console.log("Max Number of Pages");
			console.log(data.max);
			console.log("Current Page");
			console.log(pagenum);
		})
		.catch((error) => {
			console.error(error);
		});

	pagenum++;
});
